// extracted by mini-css-extract-plugin
export default {"googleBtnContainer":"styles_googleBtnContainer__gZ3Qo","title":"styles_title__Exieb"};